import PropTypes from 'prop-types';
import React from 'react';

import { withTranslation } from 'react-i18next';

import { ToastContext, WeezHeader, Button, Section, Card, Form, Select } from '@weezevent/nacre';
import Event from '../../models/eventModel';
import { default as SubscriptionModel } from '../../models/subscription';
import SubscriptionLink from '../../models/subscriptionLink';

import Loading from '../../components/loading';

import { DigitickForm, FnacForm, UniverseForm, LenndForm, TicketnetForm, PlaypassForm, SecutixForm, RegiondoForm } from './webserviceForms';

const WEBSERVICE_FORMS = {
    digitick: DigitickForm,
    fnac: FnacForm,
    universe: UniverseForm,
    lennd: LenndForm,
    ticketnet: TicketnetForm,
    playpass: PlaypassForm,
    secutix: SecutixForm,
    regiondo: RegiondoForm
};

class SubscriptionNew extends React.Component {
    constructor(...args) {
        super(...args);

        this.state = {
            isLoading: true,
            subscription: null,
            subscriptionLinks: [],
            type: '',
            organizationId: this.props.organizationId,
            subscriptionId: this.props.subscriptionId
        };
    }

    componentDidMount() {
        this.loadSubscription();
    }

    loadSubscription() {
        const { t } = this.props;
        let { organizationId, subscriptionId } = this.state;
        let subscriptionPromise = subscriptionId
            ? SubscriptionModel.get({
                  id: subscriptionId,
                  organizationId
              })
            : Promise.resolve(new SubscriptionModel());

        let subscriptionLinkPromise = subscriptionId
            ? SubscriptionLink.getAll({
                  organizationId,
                  subscriptionId
              })
            : Promise.resolve([]);

        let events = Event.getAll(
            { organizationId },
            {
                publication_status__in: 'published,draft'
            }
        );

        Promise.all([subscriptionPromise, subscriptionLinkPromise, events])
            .then(([subscription, subscriptionLinks, events]) => {
                this.setState({
                    subscription,
                    allSubscriptionLinks: subscriptionLinks,
                    subscriptionLinks,
                    events,
                    type: subscription.type,
                    login: subscription.login,
                    isLoading: false
                });
            })
            .catch(e => {
                this.toast.error(t('ticket.webservice.sucbscriptionLinks.retrievalError'));
            });
    }

    handleSubmit() {
        const { t } = this.props;
        this.setState({ isSubmiting: true });
        let { organizationId, subscription } = this.state;

        subscription.type = this.state.type;
        subscription.setInfo(this.state);

        subscription
            .save({ organizationId })
            .then(({ response }) => {
                this.setState({ isSubmiting: false, subscription: response });
                subscription.id ? this.context.success(t('ticket.webservice.modificationSuccess')) : this.context.success(t('ticket.webservice.creationSuccess'));

                this.props.history.push(`/ticket/O${organizationId}/webservices`);
            })
            .catch(error => {
                let message = t([`ticket.webservice.statuses.${error.code}`, 'ticket.webservice.creationError']);
                this.toast.error(message);
                this.setState({ isSubmiting: false });
            });
    }

    renderFields() {
        if (this.props.subscriptionId && this.state.subscription.status !== 'login_error') {
            return;
        }

        if (this.type === '') {
            return;
        }

        let Component = WEBSERVICE_FORMS[this.state.type];
        return <Component subscription={this.state.subscription} onChange={fields => this.setState(fields)} />;
    }

    render() {
        const { t } = this.props;
        const { organizationId } = this.props;

        if (this.state.isLoading) {
            return <Loading />;
        }

        return (
            <React.Fragment>
                <WeezHeader
                    title={t('ticket.webservice.addWebServices')}
                    backLink={{ onClick: () => this.props.history.push(`/ticket/O${organizationId}/webservices`) }}
                    rightComponent={[<Button primary key="primary" label={t('ticket.common.action.save')} disabled={!this.state.type} onClick={this.handleSubmit.bind(this)} />]}
                />
                <Card>
                    <Card.Header>
                        <Card.Title title={`${t('ticket.webservice.distributor')} :`} />
                    </Card.Header>
                    <Card.Content>
                        <Form onSubmit={this.handleSubmit.bind(this)} loading={this.state.isSubmiting} success={this.state.success} error={this.state.error}>
                            <Form.Field>
                                <div style={{ 'margin-bottom': '5px' }}>{t('ticket.webservice.form.choiceDistributorTitle')}</div>
                                <Select
                                    value={this.state.type}
                                    options={[
                                        { text: t('ticket.webservice.form.choiceDistributor'), value: '' },
                                        { text: 'Digitick', value: 'digitick' },
                                        { text: 'Fnac', value: 'fnac' },
                                        { text: 'Universe', value: 'universe' },
                                        { text: 'Lennd', value: 'lennd' },
                                        { text: 'Ticketnet', value: 'ticketnet' },
                                        { text: 'Playpass', value: 'playpass' },
                                        { text: 'Secutix', value: 'secutix' },
                                        { text: 'Regiondo', value: 'regiondo' }
                                    ]}
                                    onChange={(event, { value }) => {
                                        this.setState({ type: value });
                                    }}
                                    disabled={this.props.subscriptionId !== null}
                                />
                            </Form.Field>
                            {this.state.type ? <Section>{this.renderFields()}</Section> : null}
                        </Form>
                    </Card.Content>
                </Card>
            </React.Fragment>
        );
    }
}

SubscriptionNew.contextType = ToastContext;

SubscriptionNew.defaultProps = {
    subscriptionId: null
};

SubscriptionNew.propTypes = {
    subscriptionId: PropTypes.string,
    organizationId: PropTypes.string.isRequired,
    history: PropTypes.object.isRequired,
    t: PropTypes.func.isRequired
};

export default withTranslation()(SubscriptionNew);
